import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { breakpointDown } from '../utils/breakpoints'


gsap.registerPlugin(ScrollTrigger)

function setupParallaxImages(scroller)
{

  if(breakpointDown('lg')) { return false }

  let percent = 20

  gsap.utils.toArray('.js-image-parallax').forEach(element => {

    let images = element.querySelectorAll('.background-image .image, figure')
    gsap.set(images, { scale: 1.2 })
    images.forEach(image => {
      percent = image.tagName === 'FIGURE' ? 10 : percent

      gsap.fromTo(image, {yPercent: -percent}, {
        yPercent: percent,
        ease: "none",
        scrollTrigger: {
          trigger: image,
          start: "top bottom", // the default values
          end: "bottom top",
          scrub: true,
          scroller: scroller,
          //markers: true
        },
      });
    })


  })


}

export { setupParallaxImages }
